import { Box, Divider, Drawer, Stack, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { Icon } from '@verantos-dev/shared-components';
import { CohortSummaryDetails } from '@verantos-dev/types-cohorts';

import CohortCharacteristicsTabularData from './CohortCharacteristicsTabularData';

type CohortCharacteristicsDataDialogProps = {
  totalSubjectCount: number;
  cohortSummaryData: CohortSummaryDetails;
  onHideDataDialog: () => void;
};

export const CohortCharacteristicsDataDialog = ({
  totalSubjectCount,
  cohortSummaryData,
  onHideDataDialog,
}: CohortCharacteristicsDataDialogProps) => {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <Drawer
      anchor="right"
      open={true}
      onClose={onHideDataDialog}
      PaperProps={{
        sx: {
          height: '100vh', // Full height of the browser window
          width: '476px',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mx: 6,
          my: 3,
          mb: 3,
        }}
      >
        <Typography variant="h6">Demographics</Typography>
        <Box onClick={onHideDataDialog} sx={{ cursor: 'pointer', width: '24px', height: '24px' }}>
          <Icon id="cohortCharacteristicsCloseChart" icon="close" width={24} height={24} />
        </Box>
      </Box>
      <Box
        data-testid="cohortCharacteristicsTabularData"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          alignSelf: 'stretch',
          borderRadius: '4px',
          border: `1px solid  ${theme.palette.divider}`,
          width: '428px',
          mx: 6,
          mb: 6,
          overflow: 'scroll',
        }}
      >
        <Box sx={{ width: '100%', height: '100%' }}>
          {/* column header */}
          <Stack direction="row" justifyContent="space-between" sx={{ px: '14px', py: '14px' }}>
            <Typography variant="body1" fontWeight="500" color={theme.palette.text.primary}>
              {intl.formatMessage({
                id: 'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.columnLabel',
              })}
            </Typography>
            <Typography variant="body1" fontWeight="500" color={theme.palette.text.primary}>
              {`N = ${totalSubjectCount.toLocaleString()}`}
            </Typography>
          </Stack>
          <Divider />
          <CohortCharacteristicsTabularData cohortSummaryData={cohortSummaryData} />
        </Box>
      </Box>
    </Drawer>
  );
};
